$(document).on("click",".ymq-options-box label",function() {
  setTimeout(function() {
    fetch(`${window.location.href}`).then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('media-gallery .slider-counter--dots');
      document.querySelector('media-gallery .slider-counter--dots').innerHTML = html.innerHTML;
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
    });
  }, 50);
});
 $(document).on("click",".menu-drawer-close",function() {
   $('.header__icon--menu span').click()
});